import { FormInstance, Rule } from "antd/lib/form"
import i18n from "i18next"
import { countInArray } from "Shared/utils/helpers"

const TaxRules = (formInstance: FormInstance): { [key: string]: Rule[] } => ({
    taxRate: [
        { required: true, message: i18n.t("validation:required") },
        { transform: (v) => Number(v), type: "number", message: i18n.t("validation:numeric") },
        { transform: (v) => Number(v), type: "number", max: 100, message: i18n.t("validation:max.number", { max: 100 }) },
        { transform: (v) => Number(v), type: "number", min: 0, message: i18n.t("validation:min.number", { min: 0 }) },
    ],
    buCode: [
        {
            validator: (_rule: any, value: number | string) => {
                const buCodes = formInstance.getFieldsValue().taxes.map((e: any) => e.buCode)
                if (countInArray(buCodes, value) >= 2) {
                    return Promise.reject(i18n.t("validation:duplicate", { value: i18n.t("validation:bu_code") }))
                }

                return Promise.resolve()
            },
        },
    ],
})

export default TaxRules
